import common from "./common";
import roles from "./roles";
import invitations from "./invitations";
import license from "./license";
import releases from "./releases";
import spaces from "./spaces";
import spaceRestriction from "./spaceRestriction";
import seats from "./seats";
import alternisLanguages from "./alternisLanguages";
import pwa from "./pwa";

export default {
	...common,
	...roles,
	...invitations,
	...license,
	...releases,
	...spaces,
	...spaceRestriction,
	...seats,
	...alternisLanguages,
	...pwa,
};
